var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 11.5,
    viewBox: "0 0 11.5 11.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "plus",
    d: "M48.594,42.844H45.056V39.306a1.106,1.106,0,1,0-2.212,0v3.538H39.306a1.106,1.106,0,1,0,0,2.212h3.538v3.538a1.106,1.106,0,1,0,2.212,0V45.056h3.538a1.106,1.106,0,0,0,0-2.212Z",
    transform: "translate(-38.2 -38.2)",
    fill: "#5cc13e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f095d5bc1cafb3c4cd481704961191de.svg";
export { ForwardRef as ReactComponent };